import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStop, faStopwatch } from "@fortawesome/free-solid-svg-icons";
import { useTimer } from "../context/TimerContext";
import { formatarCronometro, formatarDuracao } from "../utils/taskTime";
import "./TimerBadge.css";

/**
 * Cronometro do topo.
 *
 * Enquanto conta, precisa estar visivel em qualquer tela: o erro classico do
 * controle de tempo e esquecer o relogio ligado depois de trocar de assunto.
 * Parado, vira so o total do dia - informacao util sem virar ruido.
 */
const TimerBadge = () => {
  const { emAndamento, segundos, resumo, ocupado, parar } = useTimer();

  if (!emAndamento) {
    if (!resumo?.hoje_segundos) return null;

    return (
      <Link
        to="/tarefas"
        className="timer-badge parado"
        title="Tempo apontado hoje"
        aria-label={`Tempo apontado hoje: ${formatarDuracao(resumo.hoje_segundos)}`}
      >
        <FontAwesomeIcon icon={faStopwatch} />
        <span className="timer-badge-hoje">{formatarDuracao(resumo.hoje_segundos)}</span>
      </Link>
    );
  }

  const excedeu = segundos > 8 * 60 * 60;

  return (
    <div className={`timer-badge rodando ${excedeu ? "suspeito" : ""}`}>
      <span className="timer-badge-pulso" aria-hidden="true" />

      <Link to="/tarefas" className="timer-badge-tarefa" title={emAndamento.tarefa || "Tarefa"}>
        {emAndamento.tarefa || "Tarefa"}
      </Link>

      <span className="timer-badge-relogio" aria-live="off">
        {formatarCronometro(segundos)}
      </span>

      <button
        type="button"
        className="timer-badge-parar"
        onClick={parar}
        disabled={ocupado}
        title={excedeu ? "Rodando ha mais de 8h — pare e corrija se esqueceu" : "Parar cronometro"}
        aria-label="Parar cronometro"
      >
        <FontAwesomeIcon icon={faStop} />
      </button>
    </div>
  );
};

export default TimerBadge;
